import React from 'react';
import { MessageCircle, Clock, Rocket } from 'lucide-react';
import { Button } from '@/components/ui/button';
const HowItWorksSection = () => {
  return <section id="how-it-works" className="section-container">
      <h2 className="section-title">
        We Believe in <span className="text-goldcore">Value First</span>
      </h2>
      <p className="text-center text-deepshadow max-w-3xl mx-auto mb-16 text-lg">
        We've streamlined the website creation process, making it easy for you to get a 
        professional site without the usual cost and complexity.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        {/* Step 1 */}
        <div className="step-card group">
          <div className="h-16 w-16 rounded-full bg-knightblack text-goldcore flex items-center justify-center mb-6 mx-auto md:mx-0 group-hover:scale-110 transition-transform">
            <MessageCircle size={28} />
          </div>
          <h3 className="text-xl font-bold mb-4 text-center md:text-left">
            1. Chat with KnightAI
          </h3>
          <p className="text-deepshadow/80 text-center md:text-left">
            Spend 10 minutes telling our AI agent about your business goals, brand style, and target audience.
            No design expertise needed!
          </p>
        </div>

        {/* Step 2 */}
        <div className="step-card group">
          <div className="h-16 w-16 rounded-full bg-knightblack text-goldcore flex items-center justify-center mb-6 mx-auto md:mx-0 group-hover:scale-110 transition-transform">
            <Clock size={28} />
          </div>
          <h3 className="text-xl font-bold mb-4 text-center md:text-left">
            2. We Design & Deliver in 48 Hours
          </h3>
          <p className="text-deepshadow/80 text-center md:text-left">
            Our team takes your input and creates a fully-functional, responsive website designed 
            to convert visitors into customers.
          </p>
        </div>

        {/* Step 3 */}
        <div className="step-card group">
          <div className="h-16 w-16 rounded-full bg-knightblack text-goldcore flex items-center justify-center mb-6 mx-auto md:mx-0 group-hover:scale-110 transition-transform">
            <Rocket size={28} />
          </div>
          <h3 className="text-xl font-bold mb-4 text-center md:text-left">
            3. You Launch or Scale
          </h3>
          <p className="text-deepshadow/80 text-center md:text-left">
            Take your free site and launch it, or work with us on advanced marketing strategies 
            to scale your business further.
          </p>
        </div>
      </div>

      <div className="text-center">
        <h3 className="text-2xl font-bold mb-6">
          Want us to build yours next? Start with a quick chat.
        </h3>
        <Button variant="gold" size="default">
          Chat with KnightAI
        </Button>
      </div>
    </section>;
};
export default HowItWorksSection;
